import { render } from "./Offer.vue?vue&type=template&id=71455adc&scoped=true&ts=true"
import script from "./Offer.vue?vue&type=script&lang=ts"
export * from "./Offer.vue?vue&type=script&lang=ts"

import "./Offer.vue?vue&type=style&index=0&id=71455adc&scoped=true&lang=css"

import exportComponent from "/working_dir/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-71455adc"],['__file',"src/views/Offer.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "71455adc"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('71455adc', __exports__)) {
    console.log('reload')
    api.reload('71455adc', __exports__)
  }
  
  module.hot.accept("./Offer.vue?vue&type=template&id=71455adc&scoped=true&ts=true", () => {
    console.log('re-render')
    api.rerender('71455adc', render)
  })

}


export default __exports__